/**
 * Of een e-mailadres door de server komt. Laravel toetst een adres met zijn
 * `email`-regel en daarna met `filter_var(FILTER_VALIDATE_EMAIL)`; dit is het
 * gewone ASCII-deel van wat die twee allebei goedkeuren. Wat hier doorkomt,
 * weigert de server dus niet: zo kreeg "Nieuwe deelnemer" met
 * `naam@gmail.com\` een chip en daarna alleen een kale 400.
 *
 * Bewust strenger dan de server: geen quotes, geen IP-adres als domein, geen
 * IDN in Unicode (wel als `xn--`), en een TLD van minstens twee tekens.
 *
 * Geen imports: scripts/test-email-address.mjs laadt dit bestand los.
 */

// Het lokale deel: de tekens van filter_var, in stukjes tussen losse punten.
const LOCAL = "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*";
// Een domeinlabel: letters, cijfers en streepjes, niet aan de rand, max. 63.
const LABEL = "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?";
// De TLD begint met een letter (filter_var weigert `b.1nl`) en is max. 62
// lang: Laravel weigert er een van 63.
const TLD = "[A-Za-z](?:[A-Za-z0-9-]{0,60}[A-Za-z0-9])";

const PATTERN = new RegExp(`^${LOCAL}@(?:${LABEL}\\.)+${TLD}$`);

export function isEmailAddress(value) {
  const email = String(value ?? "").trim();
  if (email.length > 254) return false;
  if (email.indexOf("@") > 64) return false;

  return PATTERN.test(email);
}
